import { useCallback, useState } from 'react';

const useNewStimulus = () => {
  const [intervalBetweenRepeatedStimuli, setIntervalBetweenRepeatedStimuli] = useState(null);
  const [stimuliUntilNextRepeat, setStimuliUntilNextRepeat] = useState(0);

  const getNextStimulus = useCallback(
    (testProgressData) => {
      const getRepetitionThreshold = () => {
        if (testProgressData.dotsForDisplay.length <= 10) {
          return 3;
        }
        return 5;
      };

      const shouldRepeatSeenStimulus = () => {
        if (testProgressData.seenDots.length === getRepetitionThreshold() && intervalBetweenRepeatedStimuli === null) {
          setIntervalBetweenRepeatedStimuli(Math.floor(testProgressData.dotsForDisplay.length / getRepetitionThreshold()));
          return true;
        }

        if (testProgressData.seenDots.length >= 5) {
          if (stimuliUntilNextRepeat === 0) {
            setStimuliUntilNextRepeat(intervalBetweenRepeatedStimuli);
            return true;
          } else setStimuliUntilNextRepeat((prevCount) => prevCount - 1);
        }
        return false;
      };

      const getRandomSeenStimulus = () => {
        const repeatedDot = testProgressData.seenDots[Math.floor(Math.random() * testProgressData.seenDots.length)];
        const dotUpdate = { ...repeatedDot, repeat: true, seenTwice: false };
        return dotUpdate;
      };

      if (shouldRepeatSeenStimulus()) {
        const newDot = getRandomSeenStimulus();
        return { newDot };
      } else {
        const randomDotIndex = Math.floor(Math.random() * testProgressData.dotsForDisplay.length);
        const newDotArray = [...testProgressData.dotsForDisplay];
        const newDot = newDotArray.splice(randomDotIndex, 1)[0];
        return { newDot, newDotArray };
      }
    },
    [intervalBetweenRepeatedStimuli, stimuliUntilNextRepeat],
  );

  return getNextStimulus;
};

export default useNewStimulus;
